import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CallcenterResourceService, CallStatus, CountryModel } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxCallcenterService {
  constructor(
    private callcenterResourceService: CallcenterResourceService,
  ) { }

  getCallUrlById(id: string): Promise<{url: string}> {
    return firstValueFrom(this.callcenterResourceService.getCallUrlById(id)) as unknown as Promise<{url: string}>;
  }

  async getLastCallByAsteriskId(asteriskId: string): Promise<LastCallInfo> {
    const info = await firstValueFrom(this.callcenterResourceService.getLastCallByOperatorId(Number(asteriskId)));
    return info as LastCallInfo;
  }

  addOrderToCall(params: {callId: string, orderId: number}): Promise<void> {
    return firstValueFrom(this.callcenterResourceService.bindOrderToCall(params.callId, {orderId: params.orderId}));
  }

  getOperatorIds(): Promise<number[]> {
    return firstValueFrom(this.callcenterResourceService.getOperatorIds());
  }
}

export interface LastCallInfo {
  phone: string;
  callId: string;
  event: CallStatus;
  mobile: boolean;
  country: CountryModel;
  orderIds: number[];
  cartOrderIds: number[];
}
